export default __webpack_public_path__ + "static/media/light_pink.6268ef53.png";